module.exports = __webpack_public_path__ + "static/media/3.f8f6f319.jpg";